import Head from 'next/head';
import { useRouter } from 'next/router';

type MetaProps = {
  title?: string;
  description?: string;
  teaserImage?: string;
  noIndex?: boolean;
};

const APP_URL = process.env.NEXT_PUBLIC_APP_URL;

const Meta = ({ title, description, teaserImage, noIndex }: MetaProps) => {
  const router = useRouter();

  const pageUrl = APP_URL + router.route;
  const defaultTwitterCardImage = APP_URL + '/images/twittercard.jpg';
  const formattedTitle = title ? `${title} · Quizzlybear` : 'Quizzlybear';

  return (
    <Head>
      <title>{formattedTitle}</title>
      <meta property="og:title" content={formattedTitle} />

      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="theme-color" content="#ffffff" />

      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      )}

      {teaserImage ? (
        <>
          <meta property="og:image" content={APP_URL + teaserImage} />
          <meta property="og:image:secure_url" content={APP_URL + teaserImage} />
        </>
      ) : (
        <>
          <meta property="og:image" content={defaultTwitterCardImage} />
          <meta property="og:image:secure_url" content={defaultTwitterCardImage} />
        </>
      )}
      <meta property="og:image:type" content="image/jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta property="og:type" content="page" />
      <meta property="og:site_name" content="Auravelle" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:url" content={pageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Head>
  );
};

export default Meta;
